/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect, useRef, useState } from 'react'

import img1 from 'assets/images/distributionPage/Privilage/1.png'
import img2 from 'assets/images/distributionPage/Privilage/2.png'
import img3 from 'assets/images/distributionPage/Privilage/3.png'
import videoSafari4 from 'assets/images/distributionPage/Privilage/stage1.mov'
import video4 from 'assets/images/distributionPage/Privilage/stage1.webm'
import videoSafari1 from 'assets/images/distributionPage/Privilage/stage2-1.mov'
import video1 from 'assets/images/distributionPage/Privilage/stage2-1.webm'
import videoSafari2 from 'assets/images/distributionPage/Privilage/stage2-2.mov'
import video2 from 'assets/images/distributionPage/Privilage/stage2-2.webm'
import videoSafari3 from 'assets/images/distributionPage/Privilage/stage2-3.mov'
import video3 from 'assets/images/distributionPage/Privilage/stage2-3.webm'
import { Video } from 'shared/components'
import { useIntersection } from 'shared/hooks'
import { delay, detectBrowser } from 'shared/utils'
import { useDistributionContext } from 'pages/Distribution/Distribution'

import classes from './Privilege.module.scss'
import classNames from 'classnames'

const isSafari = detectBrowser()?.name === 'safari'

export const Privilege = (): JSX.Element => {
  const mainVideoRef = useRef<HTMLVideoElement>(null)
  const refs = useRef<HTMLVideoElement[]>([])

  const [ref, entry] = useIntersection({})
  const [titleRef, titleRefEntry] = useIntersection({ threshold: 1 })
  const [isPlayed, setIsPlayed] = useState<boolean>(false)
  const [mainPlayed, setMainPlayed] = useState<boolean>(false)
  const videoType = isSafari ? 'video/mp4; codecs="hvc1"' : 'video/webm'
  const { isPartnerFormOpened } = useDistributionContext()
  const videoClasses = classNames({
    [classes.video]: true,
    [classes.hidden]: isPartnerFormOpened,
  })
  const items = [
    {
      src: isSafari ? videoSafari1 : video1,
      img: img1,
      title: 'Вместе с телеком оператором\n№1  в России',
      descr:
        'МТС сегодня  —  это целая эко-система,\nа KION —  неотъемлемая часть ее\nприоритетного развития',
    },
    {
      src: isSafari ? videoSafari2 : video2,
      img: img2,
      title: 'Быстрорастущий рынок\nонлайн-кинотеатров',
      descr:
        'Естественный спрос и низкая база\nпользователей расширяют возможности\nдля реализации услуги',
    },
    {
      src: isSafari ? videoSafari3 : video3,
      img: img3,
      title: 'Индивидуальный уровень\nвознаграждения',
      descr:
        'Фиксированное вознаграждение\nили разделение доходов\nза привлечение активных подписчиков',
    },
  ]

  useEffect(() => {
    const playVideos = () => {
      setIsPlayed(true)

      refs.current.forEach((el, elIndex) => {
        delay(() => playVideo(el), 1000 * elIndex)
      })
    }

    if (entry?.isIntersecting && !isPlayed) {
      delay(() => playVideos(), 1000)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entry])

  useEffect(() => {
    if (titleRefEntry?.isIntersecting && !mainPlayed) {
      setMainPlayed(true)
      playVideo(mainVideoRef.current)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [titleRefEntry])

  async function playVideo(el: HTMLVideoElement | null) {
    try {
      await el?.play()
    } catch (err) {
      console.log(err)
    }
  }

  const renderTablet = (img: string) => (
    <img className={classes.tabletImg} src={img} alt="" />
  )

  return (
    <div className={classes.wrapper}>
      <div className="container">
        <h2 className={`${classes.title} second-title`}>
          <span
            ref={titleRef}
            className="reveal-from-bottom-large"
            data-reveal-delay={50}
          >
            ПРЕИМУЩЕСТВА{'\n'}ПАРТНЕРСТВА
          </span>
          <Video
            videoRef={mainVideoRef}
            src={isSafari ? videoSafari4 : video4}
            type={videoType}
            className={videoClasses}
          />
        </h2>
        <div
          ref={ref}
          className={`${classes.privilage_container} row mt-1 reveal-from-bottom-medium`}
          data-reveal-delay={100}
        >
          {items.map((item, itemIndex) => (
            <div
              key={itemIndex}
              className={`${classes.privilage_item} col-xs-12 col-sm-4`}
            >
              <Video
                videoRef={el => ((refs.current[itemIndex] as any) = el)}
                src={item.src}
                type={videoType}
                childTablet={() => renderTablet(item.img)}
              />

              <span className={classes['privilage_item--title']}>
                {item.title}
              </span>
              <span className={classes['privilage_item--descr']}>
                {item.descr}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
